import { useIDESelectors } from '@/hooks/use-ide-selector';
import { useIDEState } from '@/hooks/use-ide-state';
import React from 'react';

export const StatusBar: React.FC = () => {
    const { state, toggleOutputPanel } = useIDEState();
    const isAnyModalOpen = useIDESelectors.useIsAnyModalOpen();

    return (
        <div
            className={`h-8 bg-vscode-bg-secondary border-t border-gray-600/30 shadow-sm flex items-center justify-between px-4 text-xs transition-all duration-200 ${
                isAnyModalOpen ? 'blur-sm opacity-50 pointer-events-none' : ''
            }`}
            onContextMenu={e => e.preventDefault()}
        >
            <a
                href='/'
                target='_blank'
                rel='noopener noreferrer'
                className='text-vscode-text-secondary hover:text-vscode-accent transition-colors cursor-pointer'
            >
                farisrehman.co.uk
            </a>
            <button
                type='button'
                onClick={toggleOutputPanel}
                aria-expanded={state.outputPanel.isVisible}
                aria-controls='ide-output-panel-container'
                className='min-h-8 px-2 rounded text-vscode-text-secondary hover:text-vscode-text'
            >
                {state.outputPanel.isVisible ? 'Hide output' : 'Show output'}
            </button>
        </div>
    );
};
